const AIDescription = ({
  hasSubmittedFeedback = false,
  description = '',
  isGenerationRestricted = false,
  id = '',
} = {}) => ({
  hasSubmittedFeedback: Boolean(hasSubmittedFeedback),
  description,
  isGenerationRestricted: Boolean(isGenerationRestricted),
  id: String(id),
});

export default AIDescription;

export type AIDescriptionProps = Partial<ReturnType<typeof AIDescription>>;
